import { render, staticRenderFns } from "./bindzfb.vue?vue&type=template&id=6157d7e0&scoped=true"
import script from "./bindzfb.vue?vue&type=script&lang=js"
export * from "./bindzfb.vue?vue&type=script&lang=js"
import style0 from "./bindzfb.vue?vue&type=style&index=0&id=6157d7e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6157d7e0",
  null
  
)

export default component.exports